import { render, staticRenderFns } from "./Component-10.vue?vue&type=template&id=14604a6a&scoped=true&"
import script from "./Component-10.vue?vue&type=script&lang=js&"
export * from "./Component-10.vue?vue&type=script&lang=js&"
import style0 from "./Component-10.vue?vue&type=style&index=0&id=14604a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14604a6a",
  null
  
)

export default component.exports